


























































































































































































































































import AbpBase from "../../../lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import {
  GetMedicineList,
  InsertMedicine,
  UpdateMedicineById,
  EnableMedicine,
  GetAutCodeList,
} from "../../../api/basicDictionary";
import { GetListByCode } from "../../../api/configureDictionary";
import { GetPinYin, GetWuBi } from "../../../api/sys";

@Component
export default class Country extends AbpBase {
  tableLoading = false;
  klfs: any = [];
  status: boolean = false;
  cancel() {
    this.dialogFormVisible = false;
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.dialogFormVisible = false;
      (this.$refs.form as any).resetFields();
    } else {
      // this.rules.alSubclass[0].required = this.dialogForm.materialType === 1076;
    }
  }
  columns = [
    {
      key: "medicineName",
      title: "药品名称",
      render: (h1: any, p: any) => {
        let h = this.$createElement;
        let style: any = {};
        if (!p.row.status) {
          style.color = "lightgray";
        }
        return h("span", { style: style }, p.row.medicineName);
      },
    },
    {
      key: "medicineModel",
      title: "规格",
    },
    {
      key: "hisCode",
      title: "his编码",
    },
    /*     {
      key: "manufacturer",
      title: "厂商",
    }, */
    {
      key: "price",
      title: "价格￥",
    },
    {
      key: "status",
      title: "是否启用",
      render: (h1: any, p: any) => {
        const h = this.$createElement;
        let style: any = {};
        if (!p.row.status) {
          style.color = "lightgray";
        }
        return h(
          "span",
          {
            style: style,
          },
          p.row.status ? "已启用" : "已停用"
        );
      },
    },
    /*     {
      key: "stopTime",
      title: "停用时间",
      width: 120, 
      render: (h1: any, p: any) => {
        let h = this.$createElement;
        if (p.row.stopTime) {
          return h("span", this.formatDateTime(p.row.stopTime));
        }
      },
    }, */
    {
      key: "",
      width: 190,
      title: "操作",
      render: (h1: any, p: any) => {
        const h = this.$createElement;
        return h("div", [
          h(
            "Button",
            {
              props: { type: "primary" },
              style: { marginRight: "20px" },
              on: {
                click: () => {
                  this.edit(p.row);
                },
              },
            },
            "编辑"
          ),
          h(
            "Button",
            {
              props: { type: "error" },
              on: {
                click: () => {
                  this.enable(p.row);
                },
              },
            },
            p.row.status ? "停用" : "启用"
          ),
        ]);
      },
    },
  ];
  key = ""; //查询条件
  page = 1; //当前页
  dialogTitle = "";
  dialogForm: any = {};
  dialogFormVisible = false;
  dialogFormLabelWidth = 200;
  tableTotalSize = 0;
  tableData = [];

  medicines = []; //药品类型下拉
  placeOfOrigins = []; // 厂家下拉
  dosageTypes = []; //剂型下拉
  units = []; // 单位下拉
  amountControls = []; // 开药控制下拉
  pharCategorys = []; //药理分类下啦
  medicineClassifications = []; // 药物分类下拉
  materialTypes = []; //物资分类
  defaultUsageWays = []; //默认用药途径
  defaultUsageMedicineTimes = []; //默认用药时间

  created() {
    this.getData();
    this.getSelects();
  }
  async queryData() {
    this.page = 1;
    await this.getData();
  }
  //获取拼音五笔
  async getCode(val: any) {
    let query = { inputStr: val };
    let res1 = await GetPinYin(query);
    let res2 = await GetWuBi(query);
    this.dialogForm.medicinePY = res1;
    this.dialogForm.medicineWB = res2;
    this.$forceUpdate();
  }
  async getCode1(val: any) {
    let query = { inputStr: val };
    let res1 = await GetPinYin(query);
    let res2 = await GetWuBi(query);
    this.dialogForm.otherNamePY = res1;
    this.dialogForm.otherNameWB = res2;
    this.$forceUpdate();
  }
  materialTypeChange(id: any) {
    this.rules.alSubclass[0].required = id === 1076;
  }

  async MedicineChange(param) {
    console.log(param)
    this.dialogForm.medicineName = param.costName;
    this.dialogForm.hisCode = param.costCode;
    await this.getCode(param.costName);
    this.dialogForm.dosage = param.dose;
    this.dialogForm.defaultUsageQuantity = param.number;
    this.units.find((x) => {
      if (x.autName == param.unit) {
        this.dialogForm.dosageUnit = x.id;
      }
    });
    this.medicines.find((x) => {
      if (x.text == param.adviceType) {
        this.dialogForm.medicineType = x.id;
      }
    });
    this.defaultUsageWays.find((x) => {
      if (x.text == param.usage) {
        this.dialogForm.defaultUsageWays = x.id;
      }
    });
  }

  async getSelects() {
    let query = { QueryString: "", SkipCount: 1, MaxResultCount: 10000 };
    let res = await GetListByCode({ input: "001" });
    this.medicines = res;
    let res1 = await GetListByCode({ input: "013" });
    this.placeOfOrigins = res1;
    let res2 = await GetListByCode({ input: "002" });
    this.dosageTypes = res2;
    let res3 = await GetAutCodeList({ Page: 1, PageSize: 10000 });
    this.units = res3.items;
    let res4 = await GetListByCode({ input: "004" });
    this.amountControls = res4;
    let res5 = await GetListByCode({ input: "005" });
    this.pharCategorys = res5;
    let res6 = await GetListByCode({ input: "006" });
    this.medicineClassifications = res6;
    let res7 = await GetListByCode({ input: "007" });
    this.materialTypes = res7;
    let res8 = await GetListByCode({ input: "008" });
    this.defaultUsageWays = res8;
    let res9 = await GetListByCode({ input: "009" });
    this.defaultUsageMedicineTimes = res9;
    let reskl = await GetListByCode({ input: "026" });
    this.klfs = reskl;
  }
  createCounty() {
    this.dialogTitle = "新增药品";
    this.dialogForm = {
      status: true,
      isCharge: false,
      medicinePY: "",
      medicineWB: "",
      otherNamePY: "",
      otherNameWB: "",
      isCommon: false,
      HideInPrintLabel: false,
      isInventory: false,
      rate: 1,
      defaultUsageQuantity: 1,
    };
    this.dialogFormVisible = true;
  }

  placeOfOriginChange(val: any) {
    this.placeOfOrigins.forEach((item: any) => {
      if (item.id === val) {
        this.dialogForm.manufacturer = item.text;
      }
    });
    // this.dialogForm.manufacturer = val.text
  }

  private async getData() {
    this.tableLoading = true;
    let payload: any = {
      QueryString: this.key,
      SkipCount: this.page,
      MaxResultCount: 10,
      Status: true,
    };
    if (this.status) {
      payload.Status = null;
    }
    let res = await GetMedicineList(payload);
    this.tableData = res.items;
    this.tableTotalSize = res.totalCount;
    this.tableLoading = false;
  }

  handleClose() {
    this.dialogFormVisible = false;
  }

  edit(row: any) {
    this.dialogTitle = "编辑药品";
    this.dialogForm = JSON.parse(JSON.stringify(row));
    this.dialogForm.placeOfOrigin = Number(this.dialogForm.placeOfOrigin);
    this.getdefaultUsageMedicineTimeName();
    this.dialogFormVisible = true;
  }
  async enable(row: any) {
    this.$Modal.confirm({
      title: "警告",
      content: "确定执行此操作吗？（非必要情况请不要执行该操作！！！）",
      onOk: async () => {
        await EnableMedicine({ id: row.id, opt: row.status ? 2 : 1 });
        this.page = 1;
        this.getData();
      },
    });
  }
  async confirm() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.dialogTitle === "新增药品") {
          let res = await InsertMedicine(this.dialogForm);
        } else if (this.dialogTitle === "编辑药品") {
          let res = await UpdateMedicineById(this.dialogForm);
        }
        this.dialogFormVisible = false;
        this.getData();
      }
    });
  }
  rules: any = {
    medicineName: [{ required: true, message: "请输入内容", trigger: "blur" }],
    medicinePY: [{ required: true, message: "请输入内容", trigger: "blur" }],
    medicineModel: [{ required: true, message: "请输入内容", trigger: "blur" }],
    sellPrice: [{ required: true, message: "请输入内容", trigger: "blur" }],
    buyPrice: [{ required: true, message: "请输入内容", trigger: "blur" }],
    medicineWB: [{ required: true, message: "请输入内容", trigger: "blur" }],
    medicineType: [{ required: true, message: "请输入内容" }],
    placeOfOrigin: [{ required: true, message: "请输入内容" }],
    dosage: [{ required: true, message: "请输入内容" }],
    packingUnit: [{ required: true, message: "请输入内容" }],
    basicUnit: [{ required: true, message: "请输入内容" }],
    rate: [{ required: true, message: "请输入内容" }],
    materialType: [{ required: true, message: "请输入内容" }],
    dosageUnit: [{ required: true, message: "请选择剂量单位" }],
    //alSubclass: [{ required: false, message: "请选择抗凝方式" }]
  };
  pageChange(val: any) {
    this.page = val;
    this.getData();
  }
  defaultUsageMedicineTimeName = "";
  getdefaultUsageMedicineTimeName() {
    var defaultUsageMedicineTime = this.defaultUsageMedicineTimes.find((x) => {
      return x.id == this.dialogForm.defaultUsageMedicineTime;
    });
    if (defaultUsageMedicineTime) {
      this.defaultUsageMedicineTimeName = defaultUsageMedicineTime.text;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/medicine/index.vue